import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { Modal } from '@frontendmentorio/design-system-v2';

import GitHubAuthButton from 'features/shared/GitHubAuthButton';
import Template from './Template';

export default function GetProForFree({ modal }) {
  const currentUser = useSelector(selectCurrentUser);

  return (
    <Modal className="items-center text-center" modal={modal}>
      <Modal.Heading level="4">
        Get Pro for <span className="uppercase">free</span>!
      </Modal.Heading>

      <div className="flex flex-col gap-5 items-center">
        <p className="text-neutral-500">
          Most companies offer learning budgets for professional growth. If
          you’re employed, you can ask your company to create a Teams account
          and cover your Pro membership. Copy the request template below and
          send it to your manager or HR.
        </p>

        {currentUser ? (
          <Template />
        ) : (
          <>
            <p className="font-secondary font-semibold text-lg">
              Please log in to see the email template.
            </p>

            <GitHubAuthButton redirectPath="/pro?getProForFree=true#plans" />
          </>
        )}
      </div>
    </Modal>
  );
}
